import { h } from 'preact';

function RoundedRight (props) {
  return (
    <svg
      width={props.width || 21}
      height={props.height || 20}
      {...props}
      fill={props.fill || '#ffffff'}
    >
      <path
        d="M10.515 0C6.147 0 2.397 2.558.825 6.19a.837.837 0 00.11.874c.199.251.525.38.852.336a.905.905 0 00.724-.546c1.298-3 4.381-5.115 8.004-5.115 4.794 0 8.661 3.688 8.661 8.261 0 4.573-3.867 8.26-8.661 8.26-3.622 0-6.706-2.114-8.004-5.113a.905.905 0 00-.724-.546.933.933 0 00-.853.336.837.837 0 00-.109.873C2.397 17.443 6.147 20 10.515 20 16.295 20 21 15.513 21 10S16.295 0 10.515 0zm.886 6.078a.913.913 0 00-.844.543.841.841 0 00.209.95l1.634 1.56H.925a.922.922 0 00-.8.43.835.835 0 000 .877c.165.271.47.436.8.432H12.4l-1.634 1.559a.843.843 0 00-.251.846.892.892 0 00.652.623c.32.079.66-.013.888-.24l3.191-3.043a.841.841 0 000-1.23l-3.191-3.043a.934.934 0 00-.654-.264z"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default RoundedRight;
